<template>
  <div>
    <div
      @click="resetOptions"
      :class="{ '-active': hasSelectedOption }"
      class="-reset -reset-filter"
    >
      Reset
    </div>
    <div class="wt2-filter-orientation">
      <div
        class="-orientation"
        v-for="(o, i) in options"
        :key="i"
        @click="optionChanged(o)"
        :class="{ selected: o.selected }"
      >
        <div :class="getOptionClass(o)">
          <i v-if="o.icon" class="wticon" :class="o.icon"
            ><span v-if="o.icon === 'wticon-users0'">&nbsp;</span></i
          >
        </div>
        {{ o.label }}
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  analytics: {
    filterOptionsSelected: 'Filter By Orientation',
  },

  computed: Object.assign(
    {
      hasSelectedOption() {
        return _.some(this.options, { selected: true });
      },
      contextFilter() {
        return this.contextFilters[this.filterKey];
      },
      options() {
        return this.contextFilter.options;
      },
    },
    app.Vuex.mapGetters(['contextFilters'])
  ),

  props: {
    filterKey: {
      type: String,
      required: true,
    },
  },

  methods: Object.assign({
    getOptionClass(o) {
      if (o.className) {
        return '-box ' + o.className;
      }
    },
    resetOptions(e) {
      if (e) {
        e.stopPropagation();
      }
      for (const o of this.options) {
        o.selected = false;
      }
      this.sendEvent();
      this.$emit('search');
    },

    optionChanged(o) {
      o.selected = !o.selected;
      this.sendEvent();
      this.$emit('search');
    },

    sendEvent() {
      const payload = {};
      this.$triggerAnalytics('filterOptionsSelected', payload);
    },
  }),
};
</script>
